import React from 'react'
import Topbar from '../../components/TopbarChina/Topbar'
import Footer from "../../components/Footer/Footer"
import ServiceCard from '../../components/ServiceCard/ServiceCard'
import "./ChinaService.scss"
import services from './serviceData'

function ChinaService() {
  return (
    <>
    <Topbar bgColor={true}/>
    <div className='china-service-box'>
      {services.map((service)=>(
      <ServiceCard serv_img={service.service_image} serv_header={service.service_name} serv_description={service.service_description} key={service.id}/>

      ))}

    </div>
    <Footer/>
    </>
    
  )
}

export default ChinaService
